import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MaterialThemeProvider } from '@material-ui/core/styles';
import DefaultTheme from '../themes/default';
import ApolloProvider from './ApolloProvider';
import TabNodeProvider from './TabNodeProvider';
import { LoadingProvider } from './LoadingProvider';
import { AlertProvider } from './AlertProvider';
import { ModalProvider } from './ModalProvider';

const theme = DefaultTheme;

const BaseAppProviders = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  return (
    <ApolloProvider>
      <BrowserRouter>
        <MaterialThemeProvider theme={theme}>
          <AlertProvider>
            <ModalProvider>
              <LoadingProvider>
                <TabNodeProvider>{children}</TabNodeProvider>
              </LoadingProvider>
            </ModalProvider>
          </AlertProvider>
        </MaterialThemeProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
};

export default BaseAppProviders;
